module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "blue"
  }, [_c('h2', {
    staticClass: "chtitle"
  }, [_vm._v("introduction")])]), _vm._v(" "), _c('div', {
    staticClass: "green"
  }, [_c('p', {
    staticClass: "noindents"
  }, [_vm._v("These quilts can be first quilts for beginners or fast quilts for more experienced quilters looking for the perfect gift, donation, or baby quilt.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentbi"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("This book offers")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentb-num"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("3"), _c('span', {
    staticClass: "left"
  }, [_vm._v("quilt designs in")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentb-num"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("3"), _c('span', {
    staticClass: "left"
  }, [_vm._v("fabric styles in")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentb-num"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("3"), _c('span', {
    staticClass: "left"
  }, [_vm._v("sizes with")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentb-num"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("3"), _c('span', {
    staticClass: "left"
  }, [_vm._v("layer-securing methods and")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentb-num"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("3"), _c('span', {
    staticClass: "left"
  }, [_vm._v("binding techniques.")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindents1"
  }, [_vm._v("Choose the size of quilt you want, and from one materials list you can make any of the three quilt designs. This means you can choose a size, shop for fabric (photos of fabric swatches will help you), and then go home and decide which quilt design you want to make. Choose a securing method and binding technique, and you’re done! See how easy?")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("We have included basic guidance to get you started and a great list of books ("), _c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter05#page_26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 26")]), _vm._v("–"), _c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter05#page_27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27")]), _vm._v(") you can refer to if you want more information.")]), _vm._v(" "), _c('div', {
    staticClass: "bluel"
  }, [_c('p', {
    staticClass: "noindents"
  }, [_vm._v("I often have the pleasure of brainstorming with Liz. I always treasure the time together. We each bring our own perspective to the table, and more often than not, they are keenly in sync. One such occasion was in the recent past. We were chatting about what sort of book was needed. As usual, life took its twists and turns, and that conversation was left on the back burner, or so I thought. Several months later I received a call from Liz, and she wanted to show me “something.” Bingo, her quilts hit the nail on the head. She asked if I would be interested in providing the general quiltmaking instructions for the book and before we knew it, Liz and I were co-authors! We are both very excited about this collaboration—fast, fun, simple projects, perfect for the beginner or the seasoned quilter who wants a quick project, in perfect C&T style.")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("-Alex")])])]), _vm._v(" "), _c('div', {
    staticClass: "bluel"
  }, [_c('p', {
    staticClass: "noindents"
  }, [_vm._v("Over the many years that Alex and I have known each other, our relationship has developed through many different experiences: quilt show chairman and vendor, quilting friends/parents, editor and author, and now co-authors. The fun just never ends. With this book, we have combined Alex’s expertise in quiltmaking knowledge, with my design and project writing skills. I hope you have fun with the simple designs, techniques, and many options that await you.")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("-Liz")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74fae2b2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/04_Introduction.vue
// module id = 66
// module chunks = 0